import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import EmptyState, { EmptyStateProps } from './EmptyState';

const messages = defineMessages({
  title: {
    id: 'components.v2.EmptyStatePastMessages.title',
    defaultMessage: "What's past (will be) past",
  },
  subtitle: {
    id: 'components.v2.EmptyStatePastMessages.subtitle',
    defaultMessage: "As you send or receive messages, they'll show up here",
  },
});

export interface EmptyStatePastMessagesProps extends Omit<EmptyStateProps, 'classes' | 'icon' | 'title' | 'subtitle'> {}

const EmptyStatePastMessages: React.FC<EmptyStatePastMessagesProps> = ({ className, ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <div className={className}>
      <EmptyState
        icon="🌓"
        title={formatMessage(messages.title)}
        subtitle={formatMessage(messages.subtitle)}
        {...rest}
      />
    </div>
  );
};

export default EmptyStatePastMessages;
